'use client'

import type { FC } from 'react'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const CustomField: FC<FieldRendererProps> = ({ field, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            {field.customRender?.({
                onChange: value => onChange(field.name, value, field)
            })}
        </FieldWrapper>
    )
}

export default CustomField
